<template>
  <svg class="icon-quote" width="22" height="17" xmlns="http://www.w3.org/2000/svg">
    <path d="M0 16.452L4.438 0h6.214L8.285 16.452H0zm10.948 0L15.386 0H21.6l-2.367 16.452h-8.285z" :fill="fill" fill-rule="evenodd"/>
  </svg>
</template>

<script>
export default {
  props: {
    fill: {
      default: 'red'
    }
  }
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/icons/icon-quote.vue